import aboutImg from "../../assets/images/about.png";

export const About = () => {
  return (
    <main className="about_layout">
      <div className="about_layout_content lg:mt-[-20px]">
        <h2 className="web_heading bar_above ">About us</h2>
        <p className="web_paragraph_1 mt-2 ">
          Sttrand is an AI-powered group purchasing platform helping small 
          and medium-sized businesses (SMEs) across Africa buy smarter 
          and save more.
        </p>
        <p className="web_paragraph_1 mt-2 ">
          Many SMEs lack the purchasing power to access the best wholesale 
          prices and reliable suppliers. Sttrand combines the collective 
          purchasing power of businesses and uses artificial intelligence 
          to aggregate demand, optimize purchasing, and unlock better pricing 
          from manufacturers and distributors. 
        </p> 
        <p className="web_paragraph_1 mt-2 "> 
          By helping businesses purchase together, we reduce costs, improve 
          supply reliability, and increase profitability. 
        </p> 
        <p className="web_paragraph_1 mt-2 "> 
          We are building the procurement infrastructure that enables African 
          businesses to access wholesale pricing, strengthen their margins, 
          and grow faster. 
        </p> 
        <p className="web_paragraph_1 mt-2 "> 
          Our Mission: 
        </p> 
        <p className="web_paragraph_1 mt-2 ">
          To increase the purchasing power of African SMEs through AI-powered 
          group purchasing. 
        </p> 
        <p className="web_paragraph_1 mt-2 ">
          Our Vision: 
        </p> 
        <p className="web_paragraph_1 mt-2 ">
          To become Africa's leading procurement and group purchasing platform 
          for small and medium-sized businesses. 
        </p> 
      </div> 
    </main>
  );
};
